import Cookies from "js-cookie";

// Scoped to the parent domain (e.g. `.dashre.us`) so the API subdomain receives
// the cookie during the SSO bounce. Host-only on `localhost` and raw IPs.
const getParentCookieDomain = (): string | undefined => {
  if (typeof window === "undefined") return undefined;
  const host = window.location.hostname;
  if (/^\d+\.\d+\.\d+\.\d+$/.test(host) || !host.includes("."))
    return undefined;
  const parts = host.split(".");
  return "." + parts.slice(-2).join(".");
};

export const parentDomainCookieOptions = (
  days: number
): Cookies.CookieAttributes => {
  const domain = getParentCookieDomain();
  return {
    expires: days,
    path: "/",
    sameSite: "lax",
    secure: process.env["REACT_APP_ENV"] !== "development",
    ...(domain ? { domain } : {}),
  };
};
